<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">邀请好友</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="shareMsg">
                <div class="card">
                    <img src="../../assets/images/bg-one.jpg" alt="">
                    <!-- <div class="cardtext">
                        <img src="../../assets/images/systemIcon.png" alt="">
                        <span>卡逸客PLUS会员</span>
                        <span>一星级VIP会员</span>
                        <span>9折</span>
                        <span>会员详情</span>
                        <i class="el-icon-arrow-right"></i>
                        <span>共享会员卡</span>
                    </div>                     -->
                </div>
                <div class="share">
                    <div class="shareName">
                        <span>姓名</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <input v-validate="'required|name'" data-vv-as="姓名"  type="text" placeholder="请输入姓名" name="name" data-vv-name="name" v-model="name">
                    </div>
                    <div class="sharePhone">
                        <span>手机号</span>&nbsp;&nbsp;
                        <input v-validate="'required|tel'" data-vv-as="手机号码" type="tel" placeholder="请输入11位手机号码" name="tel" data-vv-name="tel" v-model="mobile">
                    </div>
                    <div class="shareButton">
                        <button @click="addShareCard">确认邀请</button>
                    </div>
                </div>
            </div>
            <div class="shareFriends">共享此卡好友</div>
            <div class="shareList">
                <ul class="noFriends" v-if="noFriends">
                    <li><div class="noShareTip">暂无其他好友共享此卡</div></li>
                </ul>
                <ul v-if="!noFriends">
                    <li v-for="(shareCard, key) in shareList" :key="key">
                        <div class="item">
                            <span>{{ shareCard.shareName }}</span>
                            <span>{{ shareCard.userInfo.mobile }}</span>
                            <span>{{ shareCard.createTime }}</span>
                            <span>邀请成功</span>
                            <img src="../../assets/images/cancel.png" alt="">
                        </div>
                        <!-- <div></div> -->
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import { Navbar, TabItem } from 'mint-ui'
import { shareCardAction, showShareListAction } from '@/assets/js/api'
import { regularToast } from '@/assets/js/utilities'
import { actionWithValidator } from '@/assets/js/validation'

export default {
    name: 'shareFriends',
  data() {
    return {
        noFriends:true,
        isFront:false, 
        isVip:false,
        haveRead:false,
        selected:'1',
        cardType: '',
        sid: 0,
        mobile: '',
        name: '',
        shareList: [],
    };
  },
  computed: {},
  components: {},
  methods: {
      addShareCard () {
        actionWithValidator(this.$validator, () => {
            shareCardAction(this.sid, this.mobile, this.name, this.cardType).then (res => {
              if (res.s == 0) {
                regularToast('邀请成功')
                this.getShareCardList()
              }
            })
        }, msg => {
            alert(msg)
        })
      },
      getShareCardList () {
          showShareListAction(this.sid).then (res => {
              if (res.s == 0) {
                  this.shareList = res.list

                  this.noFriends = (this.shareList.length == 0)
              }
          })
      }
  },
  created () {
    this.sid = this.$route.query.sid
    this.cardType = this.$route.query.cardType
  },
  mounted () {
      this.getShareCardList()
  },
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
.shareMsg{
    background-color: #fff;
}
.card{
    border: 0.03rem solid #ffffff;
    border-radius: 0.55rem;
    width: 9.87rem;
    height: 6.05rem;
    position: relative;
    overflow: hidden;
}
.card :nth-child(1){
    width: 9.87rem;
    height: 6.05rem;
    margin-top: 0.2rem;
}
.cardtext{
    position: relative;
    color: #fff;
}
.cardtext :nth-child(1){
    width: 1.2rem;
    height: 1.2rem;
    position: absolute;
    top: -1.45rem !important;
    left: 0.43rem;
}
.cardtext :nth-child(2){
    font-size: 0.42rem;
    position: absolute;
    top: -1.9rem !important;
    left: 0.32rem;
}
.cardtext :nth-child(3){
    font-size: 0.32rem;
    position: absolute;
    top: -1.9rem !important;
    right: -1.2rem;
}
.cardtext :nth-child(4){
    font-size: 0.42rem;
    position: absolute;
    top: 1.8rem !important;
    left: -6rem;
}
.cardtext :nth-child(5){
    font-size: 0.32rem;
    position: absolute;
    top: 2.6rem;
    left: 6.3rem;
}
.cardtext :nth-child(7){
    font-size: 0.42rem;
    position: absolute;
    top: 1.8rem;
    left: 0.8rem;
}
.share{
    width: 100%;
    height: 4.8rem;
    margin-top: 0.92rem;
}
.shareName,
.sharePhone{
    font-size: 0.42rem;
    line-height: 0.53rem;
    color: rgba(0, 0, 0, 0.7);
    text-align: center;
}
.sharePhone{
    margin-top: 0.26rem;
}
.shareName :nth-child(2),
.sharePhone :nth-child(2){
    width: 5.24rem;
    height: 1.18rem;
    line-height: 0.61rem;
    border-radius: 0.11rem;
    background-color: rgba(0, 0, 0, 0.05);
    text-align: left;
    border: 0.03rem solid rgba(255, 255, 255, 0);
}
.shareButton{
    text-align: center;
    margin-top: 0.55rem;
}
.shareButton button{
    width: 6.71rem;
    height: 1.05rem;
    background-color: rgba(41, 158, 173, 1);
    color: #fff;
    font-size: 0.42rem;
    line-height: 0.53rem;
    border-radius: 0.16rem;
    border: 0.03rem solid rgba(255, 255, 255, 0);
}
.shareFriends{
    margin-top: 0.29rem;
    margin-left: 0.74rem;
    margin-bottom: 0.08rem;
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.3);
}
.shareList ul li{
    background-color: #fff;
    margin-top: 0.29rem;
}
.noFriends{
    height: 2.08rem;
}
.noShareTip{
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.7);
    margin-left: 0.74rem;
    padding-top: 0.26rem;
    height: 2rem;
}
.item{
    width: 100%;
    height: 1.63rem;
    position: relative;
}
.item :nth-child(1){
    position: absolute;
    top: 0.26rem;
    left: 0.79rem;
}
.item :nth-child(2){
    position: absolute;
    top: 0.26rem;
    right: 0.95rem;
}
.item :nth-child(3){
    position: absolute;
    top: 0.82rem;
    left: 0.79rem;
}
.item :nth-child(4){
    position: absolute;
    top: 0.82rem;
    right: 0.95rem;
}
.item :nth-child(5){
    width: 0.47rem;
    height: 0.47rem;
    position: absolute;
    top: -0.2rem;
    left: 9.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/card/shareFriends.vue